var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-table',{attrs:{"id":_vm.tableId,"options":_vm.options},on:{"action":_vm.getListAction}})
}
var staticRenderFns = []

export { render, staticRenderFns }